var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.121,
    height: 25.304,
    viewBox: "0 0 18.121 25.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523",
    transform: "translate(-1218.349 -837.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M21.8,20.6V7.4A5.125,5.125,0,0,0,17,2H9.8A5.125,5.125,0,0,0,5,7.4V20.6A5.125,5.125,0,0,0,9.8,26H17a5.125,5.125,0,0,0,4.8-5.4Z",
    transform: "translate(1214.007 836)",
    fill: "none",
    stroke: "#002147",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7337",
    "data-name": "Path 7337",
    d: "M14.8,5H10",
    transform: "translate(1215.009 836.601)",
    fill: "none",
    stroke: "#002147",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOtp);
export default __webpack_public_path__ + "static/media/phone-otp.d1387dc65d5d5366b7b3b5794c1f6308.svg";
export { ForwardRef as ReactComponent };